import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import BluelabComboMeterWithLeappHProbe from "../../Assets/Bluelab Combo Meter with Leap pH Probe.webp";
import "bootstrap/dist/css/bootstrap.min.css";

const Bluelab_Combo_Meter_with_Leap_pH_Probe = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 31,
      name: "Bluelab Combo Meter with Leap pH Probe",
      price: 29484,
      image: BluelabComboMeterWithLeappHProbe,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      {" "}
      {/* Add margin top to the container */}
      <div className="row">
        <div className="col-md-6">
          <div
            id="productCarousel"
            className="carousel slide"
            data-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src={BluelabComboMeterWithLeappHProbe}
                  alt="bluelab combo meter with leap pH probe"
                  className="d-block w-100"
                />
              </div>
              {/* Add more images to the carousel as needed */}
            </div>
            <a
              className="carousel-control-prev"
              href="#productCarousel"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href="#productCarousel"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">
              Bluelab Combo Meter with Leap pH Probe
            </h2>
            <p className="product-price">₹{29484}</p>
            <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <p className="product-description mt-3 text-justify">
              <h5>
                Our best-selling meter, now with the Leap pH Probe for faster,
                more accurate measurements in any substrate.
              </h5>
              <ul>
                <li>Measures pH, conductivity, and temperature effortlessly on the go</li>
                <li>Sleek, user-friendly design that's easy to use, clean, and calibrate</li>
                <li>Backlit display ensures clear visibility of all measurements</li>
                <li>The Leap pH Probe comes safely stored and ready to measure right away</li>
                <li>Features a calibration-free Conductivity Probe for convenience</li>
                <li>Includes a 2-meter cable for hard-to-reach measurement locations</li>
                <li>Automatic temperature compensation ensures precise readings anywhere</li>
                <li>Customizable scales: choose between EC, CF, PPM 500 (TDS), or PPM 700 for conductivity; °C or °F for temperature</li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      {/* Conditionally render the CartModal based on showModal */}
      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Bluelab_Combo_Meter_with_Leap_pH_Probe;
